export function formatDate(date) {
    const split = date.substr(0, 10).split('-');
    return `${split[1]}/${split[2]}/${split[0]}`;
}

export function formatDateTime(date) {
    const newDate = new Date(date);
    const stringDate = newDate.toLocaleString('en-US', {});
    const arrayDate = stringDate.split(', ');

    // Remove seconds from the time
    let timeString = arrayDate[1];
    // One digit hour, else two digit hour
    if (timeString.length === 10) {
        timeString = timeString.slice(0, 4) + timeString.slice(7, 10);
    } else {
        timeString = timeString.slice(0, 5) + timeString.slice(8, 11);
    }

    return `${arrayDate[0]} ${timeString}`;
}

// Appends the local timezone to a date
export function dateAtLocalTimezone(date) {
    if (typeof date === 'string') {
        const convertToIso = new Date(date).toISOString();
        const dateObj = new Date(); // date with user's local timezone
        return new Date(`${convertToIso.split('T')[0]}T${dateObj.toISOString().split('T')[1]}`);
    }

    return date;
}
